import { Injectable } from '@angular/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import {
  AccessPermissionService,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminRolesDataGridService {
  event: any;
  adminRolesPayload: any;
  addDatas = new Subject<[any, any, any]>();
  roleObservable$ = this.addDatas.asObservable();
  deleteRoleData = new Subject<[any]>();
  adminRoleDelete$ = this.deleteRoleData.asObservable();
  currentRoute: string = '';
  constructor(private swalService: SwalService, private accessService: AccessPermissionService) {}

  accessAllPermission(type: string) {
    const access = this.isAccess(type, 'delete');
    return access;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName == 'admin-roles' || pathName?.includes('admin-roles')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdvancedRoles,
          mainModuleName.advancedModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.AdvancedRoles,
          mainModuleName.manageOrganizationModule,
          type
        );
  };

  getAdminRolesColumn(organizationId: any, pathName: string): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'RoleName',
      headerName: 'Name',
      field: 'name',
      cellRenderer: 'rolesLink',
      cellRendererParams: {
        organizationId: organizationId,
      },
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        cellRendererParams: {
          showDelete: true,
          from: 'adminRoles',
          deleteData: (data: any) => {
            this.deleteRoleDataConfirmation(data);
          },
        },
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  deleteRoleDataConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteRoleData.next(data.idStr);
      }
    });
  }
}
